const DynamicElectionRoutingController = function (
    $scope,
    $timeout,
    AccountService,
    DynamicElectionRoutingService
) {
    $scope.available = false;
    $scope.endTime = new Date("2051-12-25T22:01:01.000Z").valueOf();
    $scope.startTime = new Date("2021-12-25T22:01:01.000Z").valueOf();
    $scope.individualId = "";
    $scope.gaID = "";
    $scope.planName = "";
    $scope.firstName = "";
    $scope.lastName = "";
    $scope.email = "";

    // Init handler is triggered in handlebars files in ui-style-guide
    $scope.init = function (endTime, startTime) {
        if (endTime) {
            $scope.endTime = new Date(endTime).valueOf();
        }
        if (startTime) {
            $scope.startTime = new Date(startTime).valueOf();
        }
    };

    const loadInitialData = () => {
        const activityTimePromise = checkActivityTime();
        const primaryGroupAccountPromise = loadPrimaryGroupAccount();
        const contactDetailsPromise = loadContactDetails();

        Promise.allSettled([
            activityTimePromise,
            contactDetailsPromise,
            primaryGroupAccountPromise
        ]).then(([activityTimeData, contactDetailsData]) => {
            if (
                activityTimeData.status === "fulfilled" &&
                contactDetailsData.status === "fulfilled"
            ) {
                // Mandatory checks to determine if the form is available to the user
                const timeIsInBounds = activityTimeData.value;
                const hasEmailToContact = contactDetailsData.value?.personalEmailAddress || "";
                const checkAvailability = timeIsInBounds && hasEmailToContact;
                if (checkAvailability) {
                    $scope.$apply(() => {
                        $scope.available = true;
                    });
                }
            }
        });
    };

    const loadPrimaryGroupAccount = () => {
        return AccountService.getPrimaryGroupAccount().then((data) => {
            $scope.individualId = data.individualId;
            $scope.gaID = data.groupId;

            return DynamicElectionRoutingService.getDetails({
                individualId: $scope.individualId,
                groupId: $scope.gaID
            }).then((details) => {
                $scope.planName = details.name;
                $scope.firstName = details.firstName;
                $scope.lastName = details.lastName;
                return details;
            });
        });
    };

    const checkActivityTime = () => {
        return DynamicElectionRoutingService.getTime().then((data) => {
            const currentTime = new Date(data.currentTime).valueOf();
            return currentTime < $scope.endTime && currentTime > $scope.startTime;
        });
    };

    const loadContactDetails = () => {
        return DynamicElectionRoutingService.getContactDetails().then((data) => {
            $scope.email = data.personalEmailAddress;
            return data;
        });
    };

    const setupWatchers = () => {
        // Available is a boolean that determines if the form is available to the user
        $scope.$watch("available", (timeIsInBounds) => {
            if (timeIsInBounds) {
                // Need to wait for the DOM to load before we can add the event listener
                $timeout(() => {
                    const electionForm = document.querySelector(".needs-validation");
                    if (!electionForm) return;
                    // Validate the form and add the was-validated class if validated
                    electionForm.addEventListener(
                        "submit",
                        (event) => {
                            if (!electionForm.checkValidity()) {
                                event.preventDefault();
                                event.stopPropagation();
                            }
                            electionForm.classList.add("was-validated");
                        },
                        false
                    );
                }, 100);
            }
        });
    };

    // Event handler is triggered in handlebars files in ui-style-guide
    $scope.selectOption = (event) => {
        const electionForm = document.querySelector(".needs-validation");
        if (!electionForm) return;
        // Get the return URL and return URL input name from the radio data atrributes
        // Some forms have multiple return URLs, so we need to know which one to use
        if (event?.currentTarget?.dataset) {
            const { returnUrl, returnUrlInput } = event.currentTarget.dataset;
            if (returnUrl && returnUrlInput) {
                const inputElement = electionForm.querySelector(`input[name='${returnUrlInput}']`);
                if (inputElement) {
                    inputElement.value = returnUrl;
                }
            }
        }
    };

    loadInitialData();
    setupWatchers();
};

DynamicElectionRoutingController.$inject = [
    "$scope",
    "$timeout",
    "AccountService",
    "DynamicElectionRoutingService"
];
export default DynamicElectionRoutingController;
